module.exports = __webpack_public_path__ + "static/RR_Back_Big-96525d94fc20dc727c177bcb4062fbe2.png";